import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import routesService from "../service/routeService";
import { getUserProfile } from "../service/auth";

const EntryPoint = () => {
	let navigate = useNavigate();
	useEffect(() => {
		let userProfile = getUserProfile();
		if (!userProfile?.token) return navigate(routesService.getLoginRoute());
		if (userProfile?.token) return navigate(routesService.getHomePageRoute());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <></>;
};

export default EntryPoint;
